export enum OpportunityChangeStatus {
    Approve = 'Approve',
    Reject = 'Reject'
}